import { bus } from "@store/dau";

/**
 * 3cad ERP v0.1 (c) 2018 Dau SRL
 * @license commercial
 */
let splashProgressEl = document.getElementById("splash-progress-bar");
import Vue from "vue";
// import Vuex from 'vuex';
import { mapGetters } from "vuex";
import VueRouter from "vue-router";
import { App, Auth } from "@3cad/nextcore";
import { NextApiClient, LogwebAPI } from "@3cad/nextcore";
import { ApiClient } from "@3cad/renderfarmapi";
import { COcomm } from "@3cad/nextcore";
import { BrowserDetector } from "@3cad/nextcore";
import { customImport } from "@/utils";
//import { loadJson, toLowerCaseKey } from "@3cad/nextcore";
import { utils } from "@3cad/nextcore";
let { loadJson, toLowerCaseKey } = utils;

import LazyTube from "vue-lazytube";
Vue.use(LazyTube);

import VueCookies from "vue-cookies";
Vue.use(VueCookies, { expires: "7d" }); // default options config: { expires: "1d", path: "/", domain: "", secure: "", sameSite: "Lax" }

// import App from '@3cad/nextcore';
// Vue.use(Vuex);

import { store } from "@store/store";

import { _ApiClientTest } from "@facades/RenderFarm";
/*import {common} from '@store/s_common';
import { projectManager }   from '@store/projectStore';
import { cadManager }       from '@store/cadStore';
import { erpManager }       from '@store/erpStore';

let store = new Vuex.Store({
    modules: {
        common:     common,
        project:    projectManager,
        cad:        cadManager,
        erp:        erpManager
    }
});*/

// main application components
import AppComp from "@custom/start.vue";

if (splashProgressEl) {
    splashProgressEl.style.width = "61%";
}

// import App from "@configurator/start.vue";

Vue.prototype.$getClosetDataFromRule = (rule, canEval = true) => {
    let closetStruct = rule.reg.var("CLOSETSTRUCT", "\t");
    let closetDiv = rule.reg.var("CLOSETDIV", "\t");
    let closetItems = rule.reg.var("CLITEMS", "\t");
    let closetAreas = rule.reg.var("CLOSETAREAS", "\t");
    return {
        closetStruct: closetStruct,
        closetDiv: closetDiv,
        closetItems: closetItems,
        closetAreas: closetAreas,
        canEval: canEval
    };
};

Vue.prototype.$getClosetDataFromTool = (canEval = false) => {
    let variants = App.iCad.getVariants_CL();
    let closetStruct = variants[0];
    let closetDiv = variants[1];
    let closetItems = variants[2];
    let closetAreas = variants[3];
    return {
        closetStruct: closetStruct,
        closetDiv: closetDiv,
        closetItems: closetItems,
        closetAreas: closetAreas,
        canEval: canEval
    };
};

// TODO: Non così utile qui
if (COcomm.isChildPage()) {
    const iFrameComm = new COcomm();

    Vue.mixin({
        data() {
            return {
                iframeCom: iFrameComm
            };
        }
    });
}

const _hostname = window.location.hostname;
let routes = [
    {
        path: "/rsalogin/:key",
        name: "rsa",
        component: () => customImport("pages/rsaLogin.vue")
    },
    {
        path: "/guestregister/:code",
        name: "guestRegister",
        component: () => customImport("pages/guestRegister.vue")
    },
    {
        path: "/guestresetpassword/:code",
        name: "guestResetPassword",
        component: () => customImport("pages/resetPassword.vue")
    },
    {
        path: "/resetpassword/:code",
        name: "resetPassword",
        component: () => customImport("pages/resetPassword.vue")
    },
    {
        path: "/unsupported",
        name: "unsupported",
        component: () => customImport("pages/unsupported.vue")
    }
];

if (splashProgressEl) {
    splashProgressEl.style.width = "75%";
}

/* Customizzazioni CATTELAN */
if (process.dau._BUILD_TYPE === "CATTELAN") {
    routes.push({
        path: "/rsalogin/:key/:currency/:coefficient",
        name: "rsaParams",
        component: () => customImport("pages/rsaLogin.vue")
    });
}

/* FIRST */
if (process.dau._BUILD_TYPE === "SCHMIDTGROUPE" || process.dau._BUILD_TYPE === "FIRST" || process.dau._BUILD_TYPE === "ECOFLASH") {
    let ImodalSgAskName;

    Vue.prototype.$sgAskModelName = options => {
        return new Promise((resolve, reject) => {
            // Build instance
            if (!ImodalSgAskName) {
                const constructor = Vue.extend(require("@custom/dialogs/modalAskName").default);
                ImodalSgAskName = new constructor({
                    el: document.createElement("div"),
                    store: store
                });
            }

            document.body.appendChild(ImodalSgAskName.$el);

            Vue.nextTick(() => {
                ImodalSgAskName.open(options).$once("close", (mode, data) => {
                    if (mode === 1) resolve(data);
                    else reject(mode);
                });
            });
        });
    };

    routes.push({
        path: "/auth",
        name: "aesAuth",
        component: () => import("@custom/pages/aesAuth.vue")
    });

    NextApiClient.prototype.aesKey = null;
    NextApiClient.refreshSession = () => {
        return new Promise((resolve, reject) => {
            if (NextApiClient.userAuthData) {
                if (NextApiClient.userAuthData.id > 0 && NextApiClient.userAuthData.name && NextApiClient.userAuthData.pwd) {
                    let params = {
                        UserID: NextApiClient.userAuthData.id,
                        UserName: NextApiClient.userAuthData.name,
                        Password: NextApiClient.userAuthData.pwd,
                        ShopId: NextApiClient.userAuthShop
                    };
                    NextApiClient.com(
                        "logweb",
                        "jWebLogin",
                        params,
                        json => {
                            resolve(json);
                        },
                        err => {
                            reject(err);
                        }
                    );
                } else reject(new Error("Missing auth data to refresh user"));
            } else if (NextApiClient.aesKey) {
                NextApiClient.com("sg", "Authenticate", { key: NextApiClient.aesKey }, resolve, reject);
            } else {
                throw new Error("Can not autenticate");
            }
        });
    };
}

/* Customizzazioni PROGEO */
if (process.dau._BUILD_TYPE === "PROGEO") {
    routes.push({
        path: "/entry/:lang/:catalog/:model/:item",
        name: "entry"
    });
    routes.push({
        path: "/entry/:lang/:catalog/:model/:item/:variants",
        name: "entry"
    });
}

/* Customizzazioni TUBES */
if (process.dau._BUILD_TYPE === "TUBES") {
    routes.push({
        path: "/entry/:lang/:catalog/:model/:classification/:article",
        name: "entry"
    });
    routes.push({
        path: "/entry/:lang/:catalog/:model/:classification/:article/:header",
        name: "entry"
    });
}

/* Customizzazioni NATUZZI */
if (process.dau._BUILD_TYPE === "NATUZZI") {
    routes.push({
        path: "/rsaloginadvanced/:loginkey/:pricelist/:pricelistselected",
        name: "rsadvance",
        component: () => customImport("pages/rsaLogin.vue")
    });
}

/* Customizzazioni FAMI */
if (process.dau._BUILD_TYPE === "FAMI") {
    routes.push({
        path: "/entry/:dShop/:eShopCode/",
        name: "entry"
    });
    routes.push({
        path: "/opengallery/:catalog/:model/:idGallery",
        name: "opengallery"
    });
    routes.push({
        path: "/entry/:dShop/:eShopCode/:catalog/:model/:idGallery",
        name: "registergallery"
    });
    routes.push({
        path: "/guestregister/:dShop/:eShopCode/:code",
        name: "guestRegisterFami",
        component: () => customImport("pages/guestRegister.vue")
    });
}

if (process.dau._BUILD_TYPE === "LEROYMERLIN") {
    let isCustomer = window.location.pathname.match(/guest.html/gi) !== null;
    Vue.mixin({
        data() {
            return {
                isCustomer: isCustomer
            };
        }
    });
}

if (process.dau._BUILD_TYPE === "LAMINAM") {
    routes.push({
        path: "/gdpr-privacy",
        name: "gdprPrivacy",
        component: () => import("@custom/pages/gdprPrivacy")
    });
}

/* Customizzazioni TONIN CASA */
if (process.dau._BUILD_TYPE === "TONINCASA") {
    routes.push({
        path: "/rsalogin/:key/:classification/:article",
        name: "rsaParams",
        component: () => customImport("pages/rsaLogin.vue")
    });
    routes.push({
        path: "/entry/:classification/:article",
        name: "entry"
    });
}

let printError = errMsg => {
    let errEl = document.getElementsByClassName("loading-error")[0];
    errEl.innerText = "Error: " + errMsg;
};

// Define to update config when is updated in App
App.onUpdateConfig = config => {
    function isIOS() {
        if (/iPad|iPhone|iPod/.test(navigator.platform)) {
            return true;
        } else {
            let valToReturn = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
            return valToReturn === 0 ? false : valToReturn;
        }
    }
    config.config.noAntiAlias = isIOS();
    // alert(isIOS());
    store.commit("setPreferences", config);
};

if (splashProgressEl) {
    splashProgressEl.style.width = "87%";
}

// Load config file asynchronously
loadJson("./config/" + process.dau._CONFIG + "?v=" + new Date().getTime())
    .then(json => {
        if (splashProgressEl) {
            splashProgressEl.style.width = "92%";
        }

        if (window.ineum /*&& window.location.hostname !== "localhost"*/) {
            if (!json.instanaKey) {
                console.error("INSTANA KEY NOT PRESENT");
            } else {
                window.ineum("reportingUrl", "https://instana.3cad.it:446/eum/");
                window.ineum("key", json.instanaKey);
                window.ineum("trackSessions");
            }
        }

        function toLowerCaseKey(obj) {
            let keys = Object.keys(obj);
            let newobj = {};
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];
                newobj[key.toLowerCase()] = obj[key];
            }
            return newobj;
        }

        // Set backend in NextApiClient
        NextApiClient.backSite = json.backsite;
        _ApiClientTest.basePath = json.config.rfServer.replace(/\/+$/, "");
        App.initTranlsator(json.config.transname);
        let config = json.config;
        let bkList = json.sites;
        let bkFind = bkList.find(r => {
            return r === json.backsite;
        });

        // Add current backend to backend list if missing
        if (!bkFind) json.sites.push(json.backsite);
        // Dau.g.backsite = json.backsite;
        // Dau.g.sites = json.sites;
        // Dau.g.config = json.config;
        // Dau.g.printings = json.printings;
        // Dau.g.dclass = toLowerCaseKey(json.dclass);
        json.dclass = toLowerCaseKey(json.dclass);

        // RENDERFARM oAuth2
        if (!json.config.rfAuthHidden) {
            const { OAuth2 } = require("@3cad/dau-auth-library");
            try {
                let redirectUrl = window.location.origin + (window.location.origin.indexOf("localhost") < 0 ? window.location.pathname : "");
                let nextRfAuth = new OAuth2("aaa-bbb-ccc", redirectUrl, token => {
                    console.error(token);
                });
                nextRfAuth.checkIfChildWindow();
            } catch (err) {
                console.error(err);
            }
        }
        // RENDERFARM oAuth2

        // Set app translator
        //App.initTranslator(Dau.g.config.transname || '');
        /*Vue.mixin({
            methods: {
                _trans(key) {
                    return Next.Translator.translate(key);
                }
            }
        });*/
        Vue.mixin({
            computed: {
                ...mapGetters(["isMaintenance", "isMaintenanceBooked"]),
                lengthUnit() {
                    return json.config.measures.length;
                },
                lengthDecimals() {
                    if ("lengthDecimals" in json.config.measures) {
                        return json.config.measures.lengthDecimals;
                    } else if (json.config.nround && json.config.nround.ext && json.config.nround.ext.num) {
                        return json.config.nround.ext.num;
                    } else {
                        return 0;
                    }
                },
                weightUnit() {
                    return json.config.measures.weight;
                },
                volumeUnit() {
                    return json.config.measures.volume;
                },
                pricesIncrease: {
                    get() {
                        return this.$store.getters["getPricesIncrease"];
                    },
                    set(newVal) {
                        this.$store.commit("setPricesIncrease", newVal);
                    }
                },
                datePickerFormat() {
                    let lang = App.getLang();
                    lang = lang.replace("_", "-");
                    switch (lang.toLowerCase()) {
                        case "d":
                            lang = "de-DE";
                            break;
                        case "en":
                        case "uk":
                            lang = "en-GB";
                            break;
                        case "us":
                            lang = "en-US";
                            break;
                        case "br":
                            lang = "pt-BR";
                            break;
                    }
                    return lang;
                }
            }
        });

        // Load dclasses components
        for (let k in json.dclass) {
            let dClass = json.dclass[k];
            if (dClass.comp) Vue.component(dClass.comp, () => customImport("dclasses/" + dClass.comp));
        }

        function loadvue() {
            if (splashProgressEl) {
                splashProgressEl.style.width = "99%";
            }
            let appRouter = new VueRouter({ routes });
            let appInstance = new Vue({
                store: store,
                router: appRouter,
                el: "#app",
                created() {
                    // Set cancelVariant for NEXT and next layout customers
                    if (["CALIA", "EPOQ", "EPOQB2B", "CALLIGARIS", "CATTELAN", "PROGEO", "NICOLETTI", "VOIT", "DIOTTI"].indexOf(process.dau._BUILD_TYPE) < 0) {
                        this.$bvConfig["$_config"] = {
                            BModal: {
                                cancelVariant: "info"
                            }
                        };
                    }
                },
                render: h => h(AppComp)
            });

            NextApiClient.onGDPRError = () => {
                appInstance.$3cadInfo({
                    title: appInstance._trans("GDPR privacy"),
                    body: appInstance._trans("User must accept GDPR privacy")
                });
            };

            NextApiClient.onManteinanceError = () => {
                LogwebAPI.isMaintenance(
                    "",
                    data => {
                        store.commit("setMantainance", data);
                    },
                    err => {
                        console.error(err);
                    }
                );
            };

            if (process.dau._BUILD_TYPE === "LAMINAM") {
                NextApiClient.onGDPRError = () => {
                    if (appInstance.$route.name !== "gdprPrivacy") appRouter.push({ name: "gdprPrivacy" });
                };
            }

            /*if (process.dau._MENU) {
                loadJson("./config/" + process.dau._MENU).then( menuJson => {
                    // Vue viene caricato solo dopo aver letto i due files di config in modo da aggiornare correttamente
                    // l'interfaccia
                    /!*Dau.g.menu = menuJson;
                    Dau.g.menudes = {};

                    function calcmenudes(xx) {
                        xx.forEach(e => {
                            e.open = e.closed ? false : true;
                            if (e.cod && !Dau.g.menudes[e.cod]) Dau.g.menudes[e.cod] = e.des;
                            if (e.data && e.data.length > 0) calcmenudes(e.data);
                        });
                    }*!/

                    // calcmenudes(menuJson);
                    new Vue({
                        store: store,
                        router: new VueRouter({routes}),
                        el: '#app',
                        render: h => h(AppComp)
                    })
                }).catch( err => {
                    printError('Missing or wrong menu configuration file');
                });
            } else {
                // Dau.g.menu = {};
                // Dau.g.menudes = {};
                new Vue({
                    store: store,
                    router: new VueRouter({routes}),
                    el: '#app',
                    render: h => h(AppComp),
                })
            }*/
        }

        // Check if is mantenance
        LogwebAPI.isMaintenance(
            "",
            data => {
                store.commit("setMantainance", data);
            },
            err => {
                console.error(err);
            }
        );

        if (config.isguest) {
            Auth.guestLogin()
                .then(profile => {
                    store.commit("setProfile", profile);
                    App.setConfig(json);
                    App.setLangFromUser(profile).then(() => {
                        loadvue();
                        App.afterLogin();
                    });
                    // loadvue();
                })
                .catch(err => {
                    json.config.isguest = false;
                    App.setConfig(json);
                    // Dau.g.config.isguest = false;
                    loadvue();
                    throw err;
                });
        } else {
            if (process.dau._BUILD_TYPE === "EPOQ" || process.dau._BUILD_TYPE === "EPOQB2B") {
                // Define default chain
                if (!localStorage["user_chainid"]) localStorage["user_chainid"] = "SNA";

                const EnvCtrl = require("@custom/_modules/EnvCtrl").default;
                const { UserAgentApplication, Constants } = require("msal");
                Constants.popUpWidth = 800;

                // Switch file for DEV, TEST, PROD environment
                loadJson("./assets/epoq/json/" + config.chainsDataFile).then(chainsDataJson => {
                    const chainsData = chainsDataJson;
                    App.setConfig(json);

                    let checkEnv = new EnvCtrl(chainsData);
                    let isCustomer = checkEnv.isCustomer();

                    Vue.prototype.$epoqCheckEnv = (...args) => {
                        return checkEnv;
                    };

                    Vue.mixin({
                        data() {
                            return {
                                checkEnv: checkEnv,
                                isCustomer: isCustomer,
                                accessError: null,
                                chainsData: chainsData
                            };
                        },
                        computed: {
                            prj() {
                                return this.$store.state.project;
                            },
                            isNGR() {
                                if (this.user && this.user.shops && this.prj) {
                                    let parentPrj = this.$store.state.parentPrj;
                                    if (this.prj.shopid !== null) {
                                        return !!this.user.shops.find(s => {
                                            return (
                                                s.cod === this.prj.shopid &&
                                                s.extra.length > 0 &&
                                                s.extra.find(e => {
                                                    return e.cod && e.cod === "ERP" && e.des && e.des === "NGR";
                                                })
                                            );
                                        });
                                    } else if (this.$store.state.epoq.isParentPrj && parentPrj) {
                                        return !!this.user.shops.find(s => {
                                            return (
                                                s.cod === parentPrj.shopid &&
                                                s.extra.length > 0 &&
                                                s.extra.find(e => {
                                                    return e.cod && e.cod === "ERP" && e.des && e.des === "NGR";
                                                })
                                            );
                                        });
                                    } else {
                                        let shop = this.$store.getters["getShop"];
                                        let extra;
                                        if (shop) extra = shop.getExtra();
                                        return !!(extra && extra["ERP"] && extra["ERP"] === "NGR");
                                    }
                                }
                                return false;
                            }
                        }
                    });

                    // Need for redirect
                    if (!isCustomer) {
                        // SELLER with ADAL
                        const AuthenticationContext = require("adal-angular");
                        const adalContext = new AuthenticationContext({
                            instance: json.adal.instance,
                            tenant: json.adal.tenant,
                            clientId: json.adal.clientId,
                            redirectUri: json.adal.redirectUri,
                            postLogoutRedirectUri: json.adal.postLogoutRedirectUri
                        });
                        if ((json.adal && process.dau._BUILD_TYPE === "EPOQ") || (json.adal && process.dau._BUILD_TYPE === "EPOQB2B")) {
                            Vue.mixin({
                                data() {
                                    return {
                                        adal: json.adal,
                                        adalContext: adalContext
                                    };
                                }
                            });
                        }
                    } else localStorage["user_chainid"] = checkEnv.getCustomerChainId();

                    loadvue();
                });
            } else if (process.dau._BUILD_TYPE === "CALLIGARIS") {
                loadJson("./assets/calligaris/json/priceListLocale.json").then(priceListData => {
                    Vue.mixin({
                        data() {
                            return {
                                calligarisPriceListData: priceListData
                            };
                        }
                    });
                    App.setConfig(json);
                    loadvue();
                });
            } else if (process.dau._BUILD_TYPE === "FIRST") {
                loadJson("./assets/first/json/countryRef.json?v=" + new Date().getTime()).then(countryRef => {
                    Vue.mixin({
                        computed: {
                            countryRef() {
                                return countryRef;
                            }
                        }
                    });
                    App.setConfig(json);
                    loadvue();
                });
            } else if (process.dau._BUILD_TYPE === "ECOFLASH") {
                loadJson("./assets/ecoflash/json/countryRef.json?v=" + new Date().getTime()).then(countryRef => {
                    Vue.mixin({
                        computed: {
                            countryRef() {
                                return countryRef;
                            }
                        }
                    });
                    App.setConfig(json);
                    loadvue();
                });
            } else if (process.dau._BUILD_TYPE === "LEROYMERLIN" && window.location.pathname.match(/guest.html/gi) !== null) {
                Auth.guestLogin()
                    .then(profile => {
                        store.commit("setProfile", profile);
                        json.config.isguest = true;
                        App.setConfig(json);
                        App.setLangFromUser(profile).then(() => {
                            loadvue();
                            App.afterLogin();
                        });
                    })
                    .catch(err => {
                        App.setConfig(json);
                        loadvue();
                        throw err;
                    });
            } else {
                if (process.dau._BUILD_TYPE === "CALIA" || process.dau._BUILD_TYPE === "NICOLETTI") {
                    let isMobile = false;
                    let ua = navigator.userAgent;
                    let browser = new BrowserDetector().getBrowser();
                    console.log("User Agent: ", ua);
                    if (ua.match(/Android/i) || ua.match(/BlackBerry/i) || ua.match(/iPhone|iPad|iPod/i) || ua.match(/Opera Mini/i) || ua.match(/IEMobile/i)) {
                        isMobile = true;
                    }
                    if (!isMobile && browser !== null && browser !== "chrome") {
                        routes.push({
                            path: "*",
                            redirect: "/unsupported"
                        });
                    }
                } else if (process.dau._BUILD_TYPE === "FIRST") {
                    let browser = new BrowserDetector().getBrowser();
                    if (browser === "IE") {
                        routes.push({
                            path: "*",
                            redirect: "/unsupported"
                        });
                    } else {
                        App.setConfig(json);
                    }
                } else {
                    App.setConfig(json);
                }
                loadvue();
            }
        }
    })
    .catch(err => {
        console.error(err);
        printError("Missing or wrong configuration file");
    });



// WEBPACK FOOTER //
// ./src/main_3cadnext.js